import app from 'flarum/forum/app';
import on from './gate';
import Notification from 'flarum/forum/components/Notification';
export default class LearnReadyNotification extends Notification {
  view() {
    return on() ? super.view() : null;
  }
  icon() {
    return 'fas fa-guitar';
  }
  href() {
    return app.route('challenges.learn', {
      slug: this.attrs.notification.content().slug
    });
  }
  content() {
    return `Your Learn page for ${this.attrs.notification.content().track} is ready.`;
  }
  excerpt() {
    return null;
  }
}